import { createWebHistory, createRouter } from "vue-router";
import Home from "@/pages/Home/index.vue";
import Unsubscribe from "@/pages/Unsubscribe/index.vue";
import History from "@/pages/History/index.vue";
import Profile from "@/pages/Profile.vue";
import Payment from "@/pages/Payment.vue";
import Detail from "@/pages/Detail.vue";
import Message from "@/pages/Message.vue";
import Upload from "@/pages/Upload.vue";
import NotFound from "@/pages/NotFound.vue";
import PlayGround from "../pages/PlayGround.vue";
import CallHandler from "../pages/CallHandler.vue";
import PaymentSuccess from "@/pages/PaymentSuccess/index.vue";
import PaymentFaild from "@/pages/PaymentFaild/index.vue";
import TV360PaymentSuccess from "@/pages/TV360/PaymentSuccess/index.vue";
import TV360PaymentFaild from "@/pages/TV360/PaymentFaild/index.vue";
import TV360RequestReceived from "@/pages/TV360/RequestReceived/index.vue";
import HandlerPlayground from "../pages/BridgeHandlers/HandlerPlayground.vue";
import HandlerSetBarTitle from "../pages/BridgeHandlers/HandlerSetBarTitle.vue";
import HandlerPlayAudioVue from "../pages/BridgeHandlers/HandlerPlayAudio.vue";
import HandlerOpenMapVue from "@/pages/BridgeHandlers/HandlerOpenMap.vue";
import HandlerShareDownloadVue from "@/pages/BridgeHandlers/HandlerShareDownload.vue";
import HandlerAddCalendarVue from "@/pages/BridgeHandlers/HandlerAddCalendar.vue";
import TermsOfService from "@/pages/TermsOfService/index.vue";
import store from "@/store";
import Loading from "@/pages/Loading/index.vue";

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/history/:id?",
    name: "History",
    component: History,
  },
  {
    path: "/handler-unsubscribe",
    name: "handler-unsubscribe",
    component: Unsubscribe,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
  },
  {
    path: "/details",
    name: "Detail",
    component: Detail,
  },
  {
    path: "/upload",
    name: "Upload",
    component: Upload,
  },
  {
    path: "/message",
    name: "Message",
    component: Message,
  },
  {
    path: "/playground",
    name: "Playground",
    component: PlayGround,
  },
  {
    path: "/handlers",
    name: "Handlers",
    component: CallHandler,
  },

  {
    path: "/payment-success",
    name: "PaymentSuccess",
    component: PaymentSuccess,
  },
  {
    path: "/payment-faild",
    name: "PaymentFaild",
    component: PaymentFaild,
  },
  {
    path: "/handler-playground",
    name: "Handlers Playground",
    component: HandlerPlayground,
  },
  {
    path: "/handler-setBarTitle",
    name: "Handlers setBarTitle",
    component: HandlerSetBarTitle,
  },
  {
    path: "/handler-playAudio",
    name: "Handlers playAudio",
    component: HandlerPlayAudioVue,
  },
  {
    path: "/handler-OpenMap",
    name: "Handlers OpenMaps",
    component: HandlerOpenMapVue,
  },
  {
    path: "/handler-ShareDownload",
    name: "Handlers Share Download",
    component: HandlerShareDownloadVue,
  },
  {
    path: "/handler-add-Calendar",
    name: "Handlers Add Calendar",
    component: HandlerAddCalendarVue,
  },
  {
    path: "/terms-of-service",
    name: "TermsOfService",
    component: TermsOfService,
  },
  {
    path: "/",
    name: "Loading",
    component: Loading,
  },

  // Buy eSIM
  {
    name: "Register Information",
    path: "/register-infor",
    component: () => import("@/pages/Ekyc/RegisterInfor.vue"),
  },
  {
    name: "Id Card",
    path: "/id-card",
    component: () => import("@/pages/Ekyc/IdCard.vue"),
  },
  {
    name: "Passport",
    path: "/passport",
    component: () => import("@/pages/Ekyc/Passport.vue"),
  },
  {
    name: "Payment information",
    path: "/verification-info",
    component: () => import("@/pages/Ekyc/VerificationInfo.vue"),
  },
  {
    name: "Payment",
    path: "/esim-payment",
    component: () => import("@/pages/EPayment/index.vue"),
  },
  {
    name: "My Orders",
    path: "/my-order",
    component: () => import("@/pages/EOrder/index.vue"),
  },
  {
    name: "My Orders Detail",
    path: "/my-order/detail",
    component: () => import("@/pages/EOrder/detail.vue"),
  },
  {
    name: "Payment Success",
    path: "/esim/payment-success",
    component: () => import("@/pages/EPayment/PaymentSuccess.vue"),
  },
  {
    name: "Support",
    path: "/support",
    component: () => import("@/pages/ESupport/index.vue"),
  },
  {
    name: "BuyNewMetfoneEsim",
    path: "/buy-new-metfone-esim",
    component: () => import("@/pages/BuyNewMetfoneEsim/index.vue"),
  },
  {
    name: "ChangeToEsimMetfone",
    path: "/change-to-esim-metfone",
    component: () => import("@/pages/ChangeToEsimMetfone/index.vue"),
  },
  {
    name: "Camera",
    path: "/camera-test",
    component: () => import("@/pages/Camera/index.vue"),
  },

  //TV360

  {
    path: "/tv360-payment-success",
    name: "TV360PaymentSuccess",
    component: TV360PaymentSuccess,
  },
  {
    path: "/tv360-payment-faild",
    name: "TV360PaymentFaild",
    component: TV360PaymentFaild,
  },
  {
    path: "/tv360-request-received",
    name: "TV360RequestReceived",
    component: TV360RequestReceived,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory("/#/"),
  routes,
});

let fromHomePage = 0;
let index = 0;
let previousRoute = null;
let lastRoute = null;
let currentRoute = null;
let checkBack = false;

//TV360
let tv360From = null;
let tv360To = null;
router.beforeEach((to, from, next) => {
  lastRoute = from;
  currentRoute = to;
  previousRoute = from;

  tv360From = from;
  tv360To = to;

  if (!store.state.loadingStore.loadingFinished) {
    return next();
  }

  const publicPages = ["/"];
  const authpage = !publicPages.includes(to.path);
  
  console.log(
    "Router From",
    from.fullPath,
    "Router To",
    to.fullPath,
    window.__ignoreActionClose,
  );
  

  //tabTV360
  if (from.fullPath.includes("/home?tab=tabTV360")) {
    if (from.fullPath == "/home?tab=tabTV360" && to.path == "/") {
      if (window.__ignoreActionClose) {
        window.__ignoreActionClose = false;
      } else {
        
        store.dispatch(
          "routerStore/setActionClose",
          true,
        );
        
        //callConfirmOnClose(from.fullPath);
      }
      return next(false);
    }
    //
    else {
      if (from.fullPath == "/home?tab=tabTV360&action=confirmpurchasetv360") {
        //console.log("TV360 - Đóng popup confirm purchase");
      } else if (
        from.fullPath ==
        "/home?tab=tabTV360&action=confirmpurchasetv360&dialog=failtv360"
      ) {
        console.log("TV360 - Đóng dialog fail purchase");
      }
      next();
    }
    return next(false);
  }
  //Esim
  else {
    if (
      to.path == "/home" &&
      (from.path == "/buy-new-metfone-esim" ||
        from.path == "/change-to-esim-metfone") &&
      to.query?.tab !== "buyMetfoneEsim"
    ) {
      return next({ path: "/home", query: { tab: "buyMetfoneEsim" } });
    }

    if (
      store.state.routerStore.isBackToHomeFromOrder &&
      from.path == "/home" &&
      (to.path == "/register-infor" ||
        to.path == "/passport" ||
        to.path == "/id-card" ||
        to.path == "/verification-info" ||
        to.path == "/esim-payment" ||
        to.path == "/my-order" ||
        to.path == "/esim/payment-success" ||
        to.path == "/my-order/detail" ||
        to.path == "/buy-new-metfone-esim" ||
        to.path == "/change-to-esim-metfone")
    ) {
      // Cho phép điều hướng eSIM từ Home (trước đây khối rỗng → không gọi next() → click Buy/Change không chạy).
      return next();
    } else {
      if (
        !authpage &&
        (to.path != "/" || (from.path == "/home" && to.path == "/"))
      ) {
        if (window.__ignoreActionClose) {
          window.__ignoreActionClose = false;
          return next(false);
        }
        if (
          store.state.routerStore.isModalClose == null &&
          !from.fullPath.includes("postservice") &&
          !(to.query.tab || from.query.tab)
        ) {
          //console.log("1-1 hiện");
          index = 0;
          
          store.dispatch(
            "routerStore/setActionClose",
            true,
          );
           
          //callConfirmOnClose(from.fullPath);
        } else if (
          store.state.routerStore.isModalClose ||
          (store.state.routerStore.isModalClose != null &&
            store.state.routerStore.isModalClose == false &&
            index <= 2)
        ) {
          //console.log("1-2 ẩn");
          index++;
          store.dispatch("routerStore/setActionModalClose", false);
        } else if (index == 0 && !from.fullPath.includes("postservice")) {
          
          store.dispatch(
            "routerStore/setActionClose",
            true,
          );
          
          //callConfirmOnClose(from.fullPath);
          //console.log("1-3 hiện");
        } else if (index > 2 && !from.fullPath.includes("postservice")) {
           
          store.dispatch(
            "routerStore/setActionClose",
            true,
          );
           
          //callConfirmOnClose(from.fullPath);
          //console.log("1-4 hiện");
        } else if (to.path == "/" && from.query.tab == "buyMetfoneEsim") {
           
          store.dispatch(
            "routerStore/setActionClose",
            true,
          );
          
          //callConfirmOnClose(from.fullPath);
        }
        //console.log("TH 1 ------", index, from.fullPath);
        return next(false);
      } else if (
        to.path == "/home" &&
        from.path == "/home" &&
        !(to.hash || from.hash) &&
        !(to.query.tab || from.query.tab)
      ) {
        if (store.state.routerStore.isModalClose) {
          console.log("2-1 an");
          store.dispatch("routerStore/setActionModalClose", false);
        } else {
          //console.log("2-2 hien");
          
          store.dispatch(
            "routerStore/setActionClose",
            true,
          );
          
          //callConfirmOnClose(from.fullPath);
        }
        //console.log("TH 2");
        return next(false);
      } else if (
        (to.path == "/home" && from.path != "/") ||
        (to.path == "/home" &&
          from.path == "/home" &&
          (to.query?.tab || from.query?.tab))
      ) {
        //console.log("TH 3", fromHomePage);
        fromHomePage++;
      } else {
        //console.log("TH 5");
        //store.dispatch("routerStore/setIsBackToHomeFromOrder", false);
        fromHomePage = 0;
      }
      next();
    }
  }
});

const handlePopState = () => {
  console.log("[popstate] router/index", tv360From.fullPath, tv360To.fullPath);

  // Change eSIM: back from id-card -> return to change-to-esim-metfone
  if (
    lastRoute.path === "/id-card" &&
    store.state.esimBuyStore?.orderDetail?.esimOrderFlow === "CHANGE_TO_ESIM" &&
    (currentRoute.path === "/register-infor" ||
      currentRoute.path === "/verification-info") &&
    !store.state.verificationInfoStore?.imgFaceIdStore
  ) {
    store.dispatch("routerStore/setIsBackToHomeFromOrder", true);
    router.replace({ path: "/change-to-esim-metfone" });
    return;
  }

  if (
    lastRoute.path == "/my-order" ||
    lastRoute.path == "/esim-payment" ||
    lastRoute.path == "/register-infor" ||
    lastRoute.path == "/esim/payment-success" ||
    lastRoute.path == "/buy-new-metfone-esim" ||
    lastRoute.path == "/change-to-esim-metfone"
  ) {
    store.dispatch("routerStore/setIsBackToHomeFromOrder", true);
    store.dispatch("headerStore/setTitle", "metfone_services");
    router.replace({ path: "/home", query: { tab: "buyMetfoneEsim" } });
    return;
  }
  //tabTV360
  if (tv360From.fullPath.includes("/home?tab=tabTV360")) {
    console.log("TV360 - popstate event");
  }
  // Other routes
  else {
    if (fromHomePage > 2) {
      console.log("=======3=======", fromHomePage);
      router.replace("/");
    }
  }
};
window.removeEventListener("popstate", handlePopState);
window.addEventListener("popstate", handlePopState);

/*
window.addEventListener("popstate", () => {
  console.log("[popstate] router/index", tv360From.fullPath, tv360To.fullPath);
  if (
    lastRoute.path == "/my-order" ||
    lastRoute.path == "/esim-payment" ||
    lastRoute.path == "/register-infor" ||
    lastRoute.path == "/esim/payment-success"
  ) {
    store.dispatch("routerStore/setIsBackToHomeFromOrder", true);
    store.dispatch("headerStore/setTitle", "metfone_services");
    router.replace({ path: "/home", query: { tab: "buyMetfoneEsim" } });
    return;
  }
  //tabTV360
  if (tv360From.fullPath.includes("/home?tab=tabTV360")) {
    console.log("TV360 - popstate event");
  }
  // Other routes
  else {
    if (fromHomePage > 2) {
      console.log("=======3=======", fromHomePage);
      router.replace("/");
    }
  }
});
*/

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

router.afterEach((to, from) => {
  window.dispatchEvent(new CustomEvent("afterHomeRoute", { detail: to }));
});

export function getPreviousRoute() {
  return previousRoute;
}

// Helper: safely call native bridge `confirmOnClose` from non-component code.
export function callConfirmOnClose(fromFullPath, app) {
  try {
    const b =
      (typeof window !== "undefined" && window.bridge) ||
      (app &&
        app.config &&
        app.config.globalProperties &&
        app.config.globalProperties.$bridge) ||
      (typeof global !== "undefined" && global.bridge);
    if (b && typeof b.callHandler === "function") {
      console.log(
        "==>>Calling bridge handler confirmOnClose from router beforeEach for TV360",
        fromFullPath,
      );
      b.callHandler("confirmOnClose", {});
    }
  } catch (err) {
    console.warn("bridge confirmOnClose call failed", err);
  }
}

// Allow router to access bridge from non-component code. Call `confirmOnClose` safely.
export function setupRouterBridge(app) {
  router.beforeEach((to, from, next) => {
    try {
      const b =
        window.bridge ||
        (app &&
          app.config &&
          app.config.globalProperties &&
          app.config.globalProperties.$bridge);
      if (b && typeof b.callHandler === "function") {
        console.log("================================");
        console.log("================================");
        console.log("from.fullPath", from.fullPath);

        if (from.fullPath == "/home?tab=tabTV360" && to.path == "/") {
          if (window.__ignoreActionClose) {
            window.__ignoreActionClose = false;
          } else {

             store.dispatch(
               "routerStore/setActionClose",
               true,
             );

            //callConfirmOnClose(from.fullPath, app);
            //console.log("Calling bridge handler confirmOnClose", from.fullPath);
          }
        }

        console.log("================================");
        console.log("================================");
      }
    } catch (err) {
      console.warn("router bridge call failed", err);
    }
    next();
  });
}

// Hàm xóa lịch sử trình duyệt
export function clearBrowserHistory() {
  try {
    // Xóa toàn bộ lịch sử session hiện tại
    if (window.history && window.history.length > 1) {
      // Thay thế state hiện tại để không có back history
      window.history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search,
      );

      // Reset các biến lưu trữ lịch sử router
      previousRoute = null;
      lastRoute = null;
      currentRoute = null;
      fromHomePage = 0;
      index = 0;

      console.log("Đã xóa lịch sử trình duyệt thành công");
      return true;
    }
    return false;
  } catch (error) {
    console.error("Lỗi khi xóa lịch sử trình duyệt:", error);
    return false;
  }
}

// Hàm xóa lịch sử và điều hướng về trang chính
export function clearHistoryAndGoHome() {
  try {
    clearBrowserHistory();
    router.replace("/home");
    console.log("Đã xóa lịch sử và điều hướng về trang chính");
    return true;
  } catch (error) {
    console.error("Lỗi khi xóa lịch sử và điều hướng:", error);
    return false;
  }
}

export default router;
